interface Config {
  API_URL: string;
  APP_ENV: string;
  DEBUG_MODE: boolean;
  COUNTRY_CODE: string | undefined;
  CURRENCY: string | undefined;
  FILE_PATH: string | undefined;
  BACKEND_API_BASE_URL: string | undefined;

  insuranceChargeCode: string[];
  GATEWAY_API_KEY: string;
  ancilarriesChargeCode: string[];
}

export const config: Config = {
  insuranceChargeCode: ['WTP', 'SCDW', 'CDW', 'PAI', 'SDW', 'FCO'],
  ancilarriesChargeCode: ['COT', 'VRF', 'ADR'],
  API_URL: process.env.REACT_APP_API_URL,
  APP_ENV: process.env.REACT_APP_ENV || 'development',
  DEBUG_MODE: process.env.REACT_APP_DEBUG === 'true',

  BACKEND_API_BASE_URL: process.env.REACT_APP_GATEWAY_API_BASE_URL || undefined,

  COUNTRY_CODE: process.env.REACT_APP_API_COUNTRY_CODE || undefined,
  FILE_PATH: process.env.FILE_PATH || undefined,

  GATEWAY_API_KEY: process.env.REACT_APP_GATEWAY_API_KEY,
  CURRENCY: 'AED',
};
